export default __webpack_public_path__ + "static/media/new-login-bg.08cc2b22.png";